import { useMemo } from "react";

import { Text } from "~/components/Text";
import { useStateManager } from "~/modules/StateManager.hooks";
import { StepConfig } from "~/utils/getFlow";

export function useStepTitle(step?: StepConfig) {
  const { state } = useStateManager();

  return useMemo(() => {
    if (!step?.id) {
      return null;
    }

    const STEP_TITLE_MAP: Record<StepConfig["id"], JSX.Element> = {
      "meeting-type": <Text i18nKey="steps.MeetingType.Title" />,
      customer: <Text i18nKey="steps.Customer.Title" />,
      employee: <Text i18nKey="steps.Employee.Title" />,
      office: state.meetingType ? (
        <Text i18nKey={`steps.Office.Title.${state.meetingType}`} />
      ) : (
        <Text i18nKey="steps.Office.Title.office" />
      ),
      questions: <Text i18nKey="steps.Questions.Title" />,
      subject: <Text i18nKey="steps.Subject.Title" />,
      timetable: <Text i18nKey="steps.Timetable.Title" />,
    };

    return STEP_TITLE_MAP[step.id];
  }, [step?.id, state.meetingType]);
}
